import React, { useState, useEffect } from 'react'
import axios from 'axios'
import MessageContainer from './MessageContainer'
import '../styles/HistoricoMensagens.css'
import config from '../config'
import historicoImage from '../assets/historicoImage.png'
import ExcelDownloadButton from './ExcelDownloadButton'

const apiUrl = config.apiUrl

const HistoricoMensagens = () => {
  const [atendentes, setAtendentes] = useState([])
  const [periodos, setPeriodos] = useState([])
  const [selectedPeriodo, setSelectedPeriodo] = useState('')
  const [selectedDia, setSelectedDia] = useState('')
  const [diasDoMes, setDiasDoMes] = useState([])

  const [usuariosBot, setUsuariosBot] = useState([])
  const [mensagensBot, setMensagensBot] = useState([])
  const [selectedUsuarioBot, setSelectedUsuarioBot] = useState('')

  const [usuariosBotCampanha, setUsuariosBotCampanha] = useState([])
  const [mensagensBotCampanha, setMensagensBotCampanha] = useState([])
  const [selectedUsuarioBotCampanha, setSelectedUsuarioBotCampanha] = useState('')
  const [selectedPeriodoCampanha, setSelectedPeriodoCampanha] = useState('')
  const [selectedDiaCampanha, setSelectedDiaCampanha] = useState('')

  const [periodosAtendente, setPeriodosAtendente] = useState({})
  const [selectedPeriodoAtendente, setSelectedPeriodoAtendente] = useState({})
  const [diasAtendente, setDiasAtendente] = useState({})
  const [selectedDiaAtendente, setSelectedDiaAtendente] = useState({})
  const [numerosAtendente, setNumerosAtendente] = useState({})
  const [mensagensAtendente, setMensagensAtendente] = useState({})
  const [selectedUsuarioAtendente, setSelectedUsuarioAtendente] = useState({})

  const [nomeRobo, setNomeRobo] = useState('bot')

  const formatarPeriodo = periodo => {
    if (!periodo) return ''
    const [mes, ano] = periodo.split('/')
    const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    return `${meses[parseInt(mes, 10) - 1]}/${ano}`
  }

  const getDiasDoMes = periodo => {
    if (!periodo) return []
    const [mes, ano] = periodo.split('/').map(Number)
    const total = new Date(ano, mes, 0).getDate()
    const hoje = new Date()
    if (ano === hoje.getFullYear() && mes === hoje.getMonth() + 1) {
      return Array.from({ length: hoje.getDate() }, (_, i) => i + 1)
    }
    return Array.from({ length: total }, (_, i) => i + 1)
  }

  useEffect(() => {
    const token = localStorage.getItem('token')
    axios.get(`${apiUrl}/parametros`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        const p = r.data.find(x => x.parametro === 'Nome do robô')
        if (p) setNomeRobo(p.valor)
      })
  }, [])

  useEffect(() => {
    const token = localStorage.getItem('token')
    axios.get(`${apiUrl}/historico/periodos`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setPeriodos(r.data))
  }, [])

  useEffect(() => {
    setDiasDoMes(getDiasDoMes(selectedPeriodo))
    setSelectedDia('')
  }, [selectedPeriodo])

  useEffect(() => {
    setDiasDoMes(getDiasDoMes(selectedPeriodoCampanha))
    setSelectedDiaCampanha('')
  }, [selectedPeriodoCampanha])

  useEffect(() => {
    if (selectedPeriodo) {
      const token = localStorage.getItem('token')
      axios.get(`${apiUrl}/historico/numeros/bot/por-periodo`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { periodo: selectedPeriodo, dia: selectedDia || undefined }
      }).then(r => setUsuariosBot(r.data))
    }
  }, [selectedPeriodo, selectedDia])

  useEffect(() => {
    if (selectedUsuarioBot) {
      const token = localStorage.getItem('token')
      axios.get(`${apiUrl}/historico/bot`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { numero: selectedUsuarioBot }
      }).then(r => setMensagensBot(r.data))
    }
  }, [selectedUsuarioBot])

  useEffect(() => {
    if (selectedPeriodoCampanha) {
      const token = localStorage.getItem('token')
      axios.get(`${apiUrl}/historico/numeros/bot/por-periodo/camp`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { periodo: selectedPeriodoCampanha, dia: selectedDiaCampanha || undefined }
      }).then(r => setUsuariosBotCampanha(r.data))
    }
  }, [selectedPeriodoCampanha, selectedDiaCampanha])

  useEffect(() => {
    if (selectedUsuarioBotCampanha) {
      const token = localStorage.getItem('token')
      axios.get(`${apiUrl}/historico/botcampanhas`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { numero: selectedUsuarioBotCampanha }
      }).then(r => setMensagensBotCampanha(r.data))
    }
  }, [selectedUsuarioBotCampanha])

  useEffect(() => {
    const token = localStorage.getItem('token')
    axios.get(`${apiUrl}/atendente`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setAtendentes(r.data))
  }, [])

  useEffect(() => {
    atendentes.forEach(a => {
      const token = localStorage.getItem('token')
      axios.get(`${apiUrl}/historico/periodos-atendente`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { numero: a.telefone }
      }).then(r => setPeriodosAtendente(p => ({ ...p, [a.telefone]: r.data })))
    })
  }, [atendentes])

  useEffect(() => {
    atendentes.forEach(a => {
      const periodo = selectedPeriodoAtendente[a.telefone]
      if (periodo) {
        const token = localStorage.getItem('token')
        axios.get(`${apiUrl}/historico/numeros/user/por-periodo`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            numero: a.telefone,
            periodo,
            dia: selectedDiaAtendente[a.telefone] || undefined
          }
        }).then(r => setNumerosAtendente(n => ({ ...n, [a.telefone]: r.data })))
      }
    })
  }, [selectedPeriodoAtendente, selectedDiaAtendente, atendentes])

  const fetchMensagensAtendente = (telefone, usuario) => {
    const token = localStorage.getItem('token')
    axios.get(`${apiUrl}/historico/user`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { numero: telefone, numeroUser: usuario }
    }).then(r => setMensagensAtendente(m => ({ ...m, [telefone]: r.data })))
  }

  return (
    <div>
      <h1>Histórico de mensagens</h1>
      <div className="historico-image-container">
        <img src={historicoImage} alt="" className="historico-image" />
      </div>
      <div className="historico-mensagens-container">

        <div className="historico-mensagens-item">
          <h2>Mensagens com {nomeRobo}</h2>
          <select onChange={e => setSelectedPeriodo(e.target.value)}>
            <option value="">Selecione um período</option>
            {periodos.map(p => (
              <option key={p} value={p}>{formatarPeriodo(p)}</option>
            ))}
          </select>
          <select onChange={e => setSelectedDia(e.target.value)} disabled={!selectedPeriodo}>
            <option value="">Selecione um dia (opcional)</option>
            {diasDoMes.map(d => (
              <option key={d} value={d}>{d}</option>
            ))}
          </select>
          <select onChange={e => setSelectedUsuarioBot(e.target.value)} disabled={!selectedPeriodo}>
            <option value="">Selecione um usuário</option>
            {usuariosBot.map(u => (
              <option key={u.numero} value={u.numero}>{u.numero}</option>
            ))}
          </select>
          {selectedUsuarioBot && (
            <MessageContainer
              title={`Mensagens com ${nomeRobo} (${selectedUsuarioBot})`}
              mensagens={mensagensBot}
              className="historico-mensagens-bot"
              nomeRobo={nomeRobo}
            />
          )}
          <ExcelDownloadButton urlSuffix="/todas/excel" defaultFilename="msgs_historico_todas.xlsx" />
        </div>

        <div className="historico-mensagens-item">
          <h2>Mensagens de Campanha com {nomeRobo}</h2>
          <select onChange={e => setSelectedPeriodoCampanha(e.target.value)}>
            <option value="">Selecione um período</option>
            {periodos.map(p => (
              <option key={p} value={p}>{formatarPeriodo(p)}</option>
            ))}
          </select>
          <select onChange={e => setSelectedDiaCampanha(e.target.value)} disabled={!selectedPeriodoCampanha}>
            <option value="">Selecione um dia (opcional)</option>
            {diasDoMes.map(d => (
              <option key={d} value={d}>{d}</option>
            ))}
          </select>
          <select onChange={e => setSelectedUsuarioBotCampanha(e.target.value)} disabled={!selectedPeriodoCampanha}>
            <option value="">Selecione um usuário</option>
            {usuariosBotCampanha.map(u => (
              <option key={u.numero} value={u.numero}>{u.numero}</option>
            ))}
          </select>
          {selectedUsuarioBotCampanha && (
            <MessageContainer
              title={`Mensagens de Campanha com ${nomeRobo} (${selectedUsuarioBotCampanha})`}
              mensagens={mensagensBotCampanha}
              className="historico-mensagens-bot-campanha"
              nomeRobo={nomeRobo}
            />
          )}
          <ExcelDownloadButton urlSuffix="/campanhas/excel" defaultFilename="campanhas_msgs.xlsx" />
        </div>

        {atendentes.map(a => (
          <div key={a.telefone} className="historico-mensagens-item">
            <h2>Atendente: {a.nome}</h2>
            <select
              onChange={e => {
                setSelectedPeriodoAtendente(p => ({ ...p, [a.telefone]: e.target.value }))
                setSelectedDiaAtendente(d => ({ ...d, [a.telefone]: '' }))
                setDiasAtendente(d => ({ ...d, [a.telefone]: getDiasDoMes(e.target.value) }))
              }}
            >
              <option value="">Selecione um período</option>
              {(periodosAtendente[a.telefone] || []).map(p => (
                <option key={p} value={p}>{formatarPeriodo(p)}</option>
              ))}
            </select>
            <select
              onChange={e => setSelectedDiaAtendente(d => ({ ...d, [a.telefone]: e.target.value }))}
              disabled={!selectedPeriodoAtendente[a.telefone]}
            >
              <option value="">Selecione um dia (opcional)</option>
              {(diasAtendente[a.telefone] || []).map(d => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
            <select
              onChange={e => {
                const usuario = e.target.value
                setSelectedUsuarioAtendente(s => ({ ...s, [a.telefone]: usuario }))
                fetchMensagensAtendente(a.telefone, usuario)
              }}
              disabled={!selectedPeriodoAtendente[a.telefone]}
            >
              <option value="">Selecione um usuário</option>
              {(numerosAtendente[a.telefone] || []).map(u => (
                <option key={u.numero} value={u.numero}>{u.numero}</option>
              ))}
            </select>
            {mensagensAtendente[a.telefone] && selectedUsuarioAtendente[a.telefone] && (
              <MessageContainer
                title={`Mensagens com Atendente (${a.nome}) e Usuário (${selectedUsuarioAtendente[a.telefone]})`}
                mensagens={mensagensAtendente[a.telefone]}
                className="historico-mensagens-atendente"
                nomeRobo={nomeRobo}
                atendenteNumero={a.telefone}
              />
            )}
            <ExcelDownloadButton
              urlSuffix={`/atendente/excel?atendenteId=${a.id}`}
              defaultFilename={`atendente_${a.nome}_msgs.xlsx`}
            />
          </div>
        ))}

      </div>
    </div>
  )
}

export default HistoricoMensagens
